import { useEventListener } from '@vueuse/core';
import { useHorizontalShadowManager } from '@/js/helpers/horizontalShadowManager';

const addShadowManager = () => {
    const CONTAINER_SELECTOR = '.breadcrumbs-container';
    const CONTENT_SELECTOR = '.breadcrumbs';
    const LEFT_SHADOW_CLASS = 'fading-text-left';
    const RIGHT_SHADOW_CLASS = 'fading-text-right';

    const DESKTOP_BREAKPOINT = 1200;

    useHorizontalShadowManager(
        CONTAINER_SELECTOR,
        CONTENT_SELECTOR,
        LEFT_SHADOW_CLASS,
        RIGHT_SHADOW_CLASS,
        DESKTOP_BREAKPOINT,
    );
};

useEventListener(document, 'DOMContentLoaded', addShadowManager);
